import { render, staticRenderFns } from "./WorkplaceModal.vue?vue&type=template&id=5c7ae2cb&"
import script from "./WorkplaceModal.vue?vue&type=script&lang=js&"
export * from "./WorkplaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports